var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreationTool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#0E65F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 17.7187V20.375H9.78125L17.6154 12.5408L14.9592 9.88458L7.125 17.7187ZM9.19333 18.9583H8.54167V18.3067L14.9592 11.8892L15.6108 12.5408L9.19333 18.9583ZM19.6696 9.48792L18.0121 7.83042C17.8704 7.68875 17.6933 7.625 17.5092 7.625C17.325 7.625 17.1479 7.69583 17.0133 7.83042L15.7171 9.12667L18.3733 11.7829L19.6696 10.4867C19.7352 10.4211 19.7873 10.3433 19.8229 10.2576C19.8584 10.1719 19.8767 10.0801 19.8767 9.98729C19.8767 9.89452 19.8584 9.80266 19.8229 9.71697C19.7873 9.63129 19.7352 9.55345 19.6696 9.48792Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreationTool);
export default __webpack_public_path__ + "static/media/creation_tool.42683dac94ecbe31365c480059e223b5.svg";
export { ForwardRef as ReactComponent };